import React from "react"
import { useState } from "react"
import { ProSidebar, Menu, MenuItem } from 'react-pro-sidebar'
import { Box, IconButton, Typography, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'
import 'react-pro-sidebar/dist/css/styles.css'
import { tokens } from '../../theme'
import { LiveTv, LockOpenOutlined } from '@mui/icons-material'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined'
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined'
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined'
import SummarizeIcon from '@mui/icons-material/Summarize'
import MapIcon from '@mui/icons-material/Map'

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  )
}

const Sidebar = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [selected, setSelected] = useState('Dashboard')

  const isAdmin = JSON.parse(localStorage.getItem('user_data')).admin
  const isOperator = JSON.parse(localStorage.getItem('user_data')).operator
  const isLivestreamer = JSON.parse(localStorage.getItem('user_data')).livestreamer

  function userType() {
    if (isAdmin)
      return "Administrador";
    else if (isOperator && isLivestreamer)
      return "Operador/Livestreams"
    else if (isOperator)
      return "Operador";
    else if (isLivestreamer)
      return "Gerenciador de Livestreams"
  }

  return (
    <Box
      sx={{
        '& .pro-sidebar-inner': {
          background: `${colors.primary[400]} !important`,
        },
        '& .pro-icon-wrapper': {
          backgroundColor: 'transparent !important',
        },
        '& .pro-inner-item': {
          padding: '5px 35px 5px 20px !important',
        },
        '& .pro-inner-item:hover': {
          color: '#868dfb !important',
        },
        '& .pro-menu-item.active': {
          color: '#6870fa !important',
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: '10px 0 20px 0',
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3" color={colors.grey[100]}></Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="100px"
                  height="100px"
                  src={`../../assets/user.png`}
                  style={{ cursor: 'pointer', borderRadius: '50%' }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: '10px 0 0 0' }}
                >
                  {JSON.parse(localStorage.getItem('user_data')).username}
                </Typography>
                <Typography variant="h5" color={colors.greenAccent[500]}>
                  {userType()}
                </Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : '10%'}>
            <Item
              title="Dashboard"
              to="/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            {isAdmin && (
              <Item
                title="Time"
                to="/team"
                icon={<PeopleOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
            )}
            {isAdmin && (
              <Item
                title="Proprietários"
                to="/owners"
                icon={<PeopleOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
            )}
            {(isAdmin || isOperator) && (
              <Item
                title="Dispositivos"
                to="/devices"
                icon={<ContactsOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
            )}
	  		{(isAdmin || isLivestreamer) && (
				<Item title="Clientes de notificações" to="/notification-clients" icon={<ContactsOutlinedIcon />} selected={selected} setSelected={setSelected} />
			)}
            {(isAdmin || isOperator) && (
              <Item
                title="Lista Branca"
                to="/whitelist"
                icon={<LockOpenOutlined />}
                selected={selected}
                setSelected={setSelected}
              />
            )}
            {(isAdmin || isLivestreamer) && (
              <Item
                title="Livestreams"
                to="/livestreams"
                icon={<LiveTv />}
                selected={selected}
                setSelected={setSelected}
              />
            )}
            {(isAdmin || isOperator) && (
              <Item
                title="Relatórios"
                to="/events"
                icon={<SummarizeIcon />}
                selected={selected}
                setSelected={setSelected}
              />
            )}
            {(isAdmin) && (
              <Item
                title="Localizações"
                to="/worldview"
                icon={<MapIcon />}
                selected={selected}
                setSelected={setSelected}
              />
            )}
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  )
}

export default Sidebar
